import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function XrfbudgetpsflineReducer(state = initialState.xrfbudgetpsfline, action: any) {
  switch (action.type) {
    case types.SAVE_XRFBUDGETPSFLINE_SUCCESS:
      return action.xrfbudgetpsfline;
    default:
      return state;
  }
}
